const ENVIRONMENT = "PRD";
let URL = {};

switch (ENVIRONMENT) {
    case "PRE":
        URL.API_WISHLIST = "https://wishlist-api.pre.superbid.net";
        URL.API_ACCOUNTS = "https://accounts.pre.superbid.net";
        URL.API_S4DIGITAL = "https://preapi.s4bdigital.net";
        URL.MYACCOUNT = "https://myaccount.pre.superbid.com";
        URL.MARKETPLACE = "https://prefaststore.superbid.net";
        break;
    case "STG":
        URL.API_WISHLIST = "https://wishlist-api.stage.superbid.net";
        URL.API_ACCOUNTS = "https://accounts.stage.superbid.net";
        URL.API_S4DIGITAL = "https://stgapi.s4bdigital.net";
        URL.MYACCOUNT = "https://myaccount.stg.superbid.com";
        URL.MARKETPLACE = "https://stgwww.superbid.net";
        break;
    case "PRD":
        URL.API_WISHLIST = "https://wishlist-api.superbid.net";
        URL.API_ACCOUNTS = "https://accounts.superbid.net";
        URL.API_S4DIGITAL = "https://api.s4bdigital.net";
        URL.MYACCOUNT = "https://myaccount.superbid.com";
        URL.MARKETPLACE = "https://www.superbid.net";
        break;
    default:
        break;
}

export const Config = {
    API_WISHLIST_URL: URL.API_WISHLIST,
    API_ACCOUNTS_URL: URL.API_ACCOUNTS,
    API_S4DIGITAL: URL.API_S4DIGITAL,
    API_MYACCOUNT_URL: URL.MYACCOUNT,
    API_MARKETPLACE_URL: URL.MARKETPLACE,
    CLIENT_ID: "33b3e010b47b877652c8233fb7446300e0487b3a-sbws-wishlist",
}
